export default __webpack_public_path__ + "static/media/logo-dark2.68503383.png";